export const handleHasHCAccess = (usersProfileConnected) => {
  let hasHCAccess = false

  if (usersProfileConnected?.isCentre) hasHCAccess = true
  if (usersProfileConnected?.isDoctor) hasHCAccess = true
  if (usersProfileConnected?.isSecretary) hasHCAccess = true

  return hasHCAccess
}
